module.exports = __webpack_public_path__ + "img/gu.b08ac0bd.svg";